import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerPrivacyService } from './customer-privacy.service';
import { CustomerPrivacyPipe } from './customer-privacy.pipe';

@NgModule({
    declarations: [CustomerPrivacyPipe],
    imports: [CommonModule],
    providers: [CustomerPrivacyService, CustomerPrivacyPipe],
    exports: [CustomerPrivacyPipe],
})
export class CustomerPrivacyModule {}
